import React from 'react';
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider, Paper } from '@mui/material';
import { Dashboard, People, Schedule, CalendarToday, Payment, BarChart, Settings, Logout, ChevronRight } from '@mui/icons-material';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import Logo from "../assets/SJ-logo.png";
import { useNavigate, useLocation } from "react-router-dom";
import './sidebar.css';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import en_ja from "../en-ja-map";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { id: 'dashboard', label: en_ja["Dashboard"] || 'Dashboard', icon: <Dashboard />, linkName: 'dashboard' },
    { id: 'booking-management', label: en_ja["Booking Management"] || 'Booking Management', icon: <Schedule />, hasArrow: true, linkName: 'booking-management' },
    { id: 'patient-management', label: en_ja["Patient Management"] || 'Patient Management', icon: <People />, hasArrow: true, linkName: 'patient-management' },
    { id: 'appointments-slots', label: en_ja["Appointments & Slots"] || 'Appointments & Slots', icon: <CalendarToday />, hasArrow: true, linkName: 'appointment' },
    { id: 'doctor-management', label: en_ja["Doctor Management"] || 'Doctor Management', icon: <VaccinesIcon />, linkName: 'doctor-management' },
    { id: 'prescription-management', label: en_ja["Prescription Management"] || 'Prescription Management', icon: <TextSnippetIcon />, linkName: 'prescription-management' },
    // Map has "Billings & Payments" (plural). Keep fallback if singular key isn't present.
    //{ id: 'billings-payments', label: en_ja["Billing & Payments"] || en_ja["Billings & Payments"] || 'Billing & Payments', icon: <Payment />, linkName: 'billings-payments' }
  ];

  const isActiveRoute = (linkName) => { return location.pathname === `/${linkName}`; };
  const handleNavigation = (linkName) => { navigate(`/${linkName}`); };
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <Paper elevation={0} className="sidebar-container">
      <Box className="sidebar-logo-section">
        <Box
          component="img"
          src={Logo}
          alt={en_ja["Shop Japan Logo"] || "Shop Japan Logo"}
          onClick={() => navigate('/dashboard')}
          className="sidebar-logo"
        />
      </Box>
      <Box className="sidebar-nav-section">
        <List className="sidebar-nav-list">
          {menuItems.map((item) => {
            const isActive = isActiveRoute(item.linkName);
            return (
              <ListItem key={item.id} disablePadding className="sidebar-nav-item">
                <ListItemButton onClick={() => handleNavigation(item.linkName)} className={`sidebar-nav-button ${isActive ? 'active' : ''}`}>
                  <Box className="sidebar-nav-content">
                    <ListItemIcon className="sidebar-nav-icon">{item.icon}</ListItemIcon>
                    <ListItemText primary={item.label} primaryTypographyProps={{ className: 'sidebar-nav-text' }} />
                  </Box>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>
      {/* <Box className="sidebar-logout-section">
        <Divider className="sidebar-divider" />
        <List className="sidebar-logout-list">
          <ListItem disablePadding>
            <ListItemButton onClick={handleLogout} className="sidebar-logout-button">
              <ListItemIcon className="sidebar-logout-icon"><Logout /></ListItemIcon>
              <ListItemText primary="Logout" primaryTypographyProps={{ className: 'sidebar-logout-text' }} />
            </ListItemButton>
          </ListItem>
        </List>
      </Box> */}
    </Paper>
  );
};

export default Sidebar;
